import React, { Component } from "react";
import Details from "./Details";

class Results extends Component {
  constructor(props) {
    super();
  }

  render() {
    let appName = this.props.appName;
    let totalTimeSaved = this.props.totalSaved;
    let totalSaving = this.props.savingPerYear;
    let reconciliations = this.props.reconciliations;
    let statement = this.props.statement;
    let transfer = this.props.transfer;
    let lockbox = this.props.lockbox;
    let research = this.props.research;
    let positivePay = this.props.positivePay;
    let stopPayment = this.props.stopPayment;
    let newAccount = this.props.newAccount;
    let accountStaff = this.props.accountStaff;
    let imageArray = this.props.imageArray;

    if (!this.props.timerPassed) {
      return (
        <div className="in-progress-spinner">
          <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
        </div>
      );
    } else {
      return (
        <Details
          appName={appName}
          totalSaved={totalTimeSaved}
          totalSaving={totalSaving}
          reconciliations={reconciliations}
          statement={statement}
          transfer={transfer}
          lockbox={lockbox}
          research={research}
          positivePay={positivePay}
          stopPayment={stopPayment}
          newAccount={newAccount}
          accountStaff={accountStaff}
          imageArray={imageArray}
        />
      );
    }
  }
}

export default Results;
